import { Facility } from "./facility.definition";
import { Location, UserInfo } from "./user.definition";

export const DEFAULT_SECRETARY_IMAGE_MALE = "/image/manSecretary.png";
export const DEFAULT_SECRETARY_IMAGE_FEMALE = "/image/womanSecretary.png";

export type Secretary = UserInfo & SecretaryInfo;
export type SecretaryInfo = {
  id: number;
  userId?: number;
  healthcareFacility: Facility;
};

export type SecretaryUpdate = Omit<Secretary, "id" | "healthcareFacility">;

export type CreateSecretaryPayload = {
  firstName: string;
  lastName: string;
  email: string;
  civility: string;
  password?: string;
  roleName: string;
  healthcareFacilityId: number;
  phoneNumber: string;
  preferredNotificationMethods: string[];
  dateOfBirth: string;
  locations?: Location[];
};

export type UpdateSecretaryPayload = Omit<CreateSecretaryPayload, "password">;
